'use client';

import { Form, FormControl, HiddenField, SubmitButton, type ActionResult } from '@36node/next-form';
import { useState } from 'react';
import { toast } from 'sonner';

// import { Checkbox } from 'src/components/ui/checkbox';
import { Input, PasswordInput } from 'src/components';
import { CaptchaInput } from 'src/components/captcha';
import { Captcha, createCaptcha } from 'src/services/auth';

import { loginAction } from './action';
import { loginSchema } from './schema';

interface LoginFormProps {
  from?: string;
  defaultCaptcha: Captcha;
}

export function LoginForm({ from, defaultCaptcha, ...props }: LoginFormProps) {
  const [captcha, setCaptcha] = useState<Captcha>(defaultCaptcha);
  const [loading, setLoading] = useState(false);

  const handleFail = (result: ActionResult) => {
    if (result.message) {
      toast.warning(result.message);
    }
  };
  const handleRefreshCaptcha = async () => {
    setLoading(true);
    const captcha = await createCaptcha();
    setCaptcha(captcha);
    setLoading(false);
  };

  return (
    <Form schema={loginSchema} action={loginAction} onFail={handleFail} {...props}>
      <HiddenField name="from" value={from} />
      <HiddenField name="captchaKey" value={captcha.key} />

      <FormControl name="login" label="账号">
        <Input placeholder="用户名/手机号" autoComplete="login" />
      </FormControl>

      <FormControl name="password" label="密码">
        <PasswordInput placeholder="请输入密码" autoComplete="password" />
      </FormControl>

      <FormControl name="captchaCode" label="验证码">
        <CaptchaInput
          onRefreshCaptcha={handleRefreshCaptcha}
          captchaImage={captcha.image}
          loading={loading}
          placeholder="请输入验证码"
        />
      </FormControl>

      <SubmitButton className="w-full">登录</SubmitButton>
    </Form>
  );
}
